import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import Minus from "../../icons/minus.svg";
import Plus from "../../icons/plus.svg";
import { validationPatterns } from "../../utils/validationPatterns";
import { QuantityInputButton } from "./QuantityInputButton";
import { QuantityInputMessage } from "./QuantityInputMessage";
import styles from "./QuantityInput.module.scss";
export const QuantityInput = ({ value = 0, disabled = false, pending = false, canZero = false, displayMessage = true, disabledMessage = "", disabledAdd = false, hoverLimitDisplay = true, orderLimitEnabled = false, productLimitCurrency, maxOrderLimit, quantityOrderLimit = { quantityLimit: 0, isLimit: 0 }, minQuantity = 0, onChange, }) => {
    const [isShown, setIsShown] = useState(false);
    const [isQuantityReached, setIsQuantityReached] = useState(false);
    const [isMinimumQuantityReached, setIsMinimumQuantityReached] = useState(false);
    const orderQuantityLimitEnabled = quantityOrderLimit.isLimit === 1;
    const showHoverLimit = isShown && hoverLimitDisplay && !disabledAdd;
    const handleInputChange = useCallback((event) => {
        const reg = new RegExp(validationPatterns.PHONE_NUMBER);
        let currentValue = event.target.value;
        if (currentValue) {
            currentValue = parseInt(currentValue, 10);
            if (isNaN(currentValue) ||
                !reg.test(event.target.value) ||
                currentValue < 0 ||
                (!canZero && currentValue === 0) ||
                (quantityOrderLimit?.quantityLimit && currentValue > quantityOrderLimit.quantityLimit)) {
                return false;
            }
        }
        onChange(currentValue);
    }, []);
    const onBlur = (event) => {
        const currentValue = event.target.value;
        if (!currentValue) {
            onChange(minQuantity);
        }
    };
    useEffect(() => {
        setIsQuantityReached(value >= quantityOrderLimit.quantityLimit && orderQuantityLimitEnabled);
        setIsMinimumQuantityReached(value === minQuantity);
    }, [orderQuantityLimitEnabled, quantityOrderLimit.quantityLimit, value]);
    return (_jsxs("div", { className: `${styles.container} ${pending ? styles.pending : ""}`, children: [_jsx(QuantityInputButton, { value: value, canZero: true, onChange: onChange, disabled: isMinimumQuantityReached || disabled, disabledMessage: disabledMessage, changeValue: -1, testId: "quantityMinus", component: Minus, className: styles.minusIcon }), _jsx("input", { value: value, className: styles.input, disabled: disabled, title: disabled ? disabledMessage : "", onChange: handleInputChange, onBlur: onBlur, "data-testid": "cartQuantity" }), _jsx(QuantityInputButton, { value: value, onChange: onChange, disabled: isQuantityReached || disabled || disabledAdd, disabledMessage: disabledMessage, changeValue: 1, testId: "quantityPlus", component: Plus, handleOnMouseEnter: () => setIsShown(true), handleOnMouseLeave: () => setIsShown(false) }), displayMessage && (_jsx(QuantityInputMessage, { orderLimitEnabled: orderLimitEnabled, showHoverLimit: showHoverLimit, maxOrderLimit: maxOrderLimit, productLimitCurrency: productLimitCurrency }))] }));
};
//# sourceMappingURL=QuantityInput.js.map